export default __webpack_public_path__ + "shake-extension-picker.png";